import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

function FicheSalarie() {
  const { id } = useParams();
  const [salarié, setSalarié] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_URL = `${process.env.REACT_APP_API_URL}/api/collaborateurs`; // Ajoute "/api" ici

  useEffect(() => {
    const fetchSalarié = async () => {
      try {
        const response = await axios.get(`${API_URL}/${id}`);
        setSalarié(response.data);
      } catch (error) {
        console.error('Erreur lors de la récupération du salarié :', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSalarié();
  }, [id, API_URL]); // Ajoute API_URL ici

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  if (!salarié) {
    return <div className="not-found">Salarié non trouvé.</div>;
  }

  return (
    <div className="fiche-salarie-container">
      <h1 className="fiche-salarie-title">Fiche de {salarié.prenom} {salarié.nom}</h1>
      <table className="salarié-table">
        <tbody>
          <tr>
            <td>Poste</td>
            <td>{salarié.poste}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td>{salarié.email}</td>
          </tr>
          <tr>
            <td>Date d'embauche</td>
            <td>{new Date(salarié.date_embauche).toLocaleDateString()}</td>
          </tr>
          <tr>
            <td>Statut</td>
            <td>{salarié.statut}</td>
          </tr>
        </tbody>
      </table>
      <Link to="/" className="back-link">Retour à la liste</Link>
    </div>
  );
}

export default FicheSalarie;
